// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "fa2ec626",
    "hash": "fa2ec626",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "fa2ec626",
    "semverString": null,
    "version": "2026.6.0.6"
};
/* tslint:enable */
